import BaseService from "./BaseService.js";

class DSService extends BaseService {
  getData(baseUri, query) {
    return this.apiGet({
      url: `/${baseUri}/data`,
      params: query
    });
  }

  submit(baseUri, payload) {
    return this.apiPost({
      url: `/${baseUri}`,
      data: payload,
    });
  }
}

export default new DSService();
